import styled from '@emotion/styled';

import { commonColors } from 'application/theme';

export const Content = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  padding: 4px 16px 24px 16px;
`;

export const DealInfo = styled('div')`
  display: flex;
  align-items: center;
  gap: 16px;

  > p {
    color: ${commonColors.grey900};
    font-family: Unica77;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
  }
`;

export const ImageWrapper = styled('div')`
  position: relative;
  display: flex;
  width: 90px;
  height: 95px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  > img {
    width: 90px;
    height: 95px;
    border-radius: 8px;
  }
`;

export const ConditionsList = styled('ol')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: decimal;
  list-style-position: inside;
  list-style-type: decimal;
  margin-block-start: 0px;
  margin-block-end: 0px;
  padding-inline-start: 0px;

  > li {
    color: ${commonColors.grey900};
    font-family: Unica77;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.08px;

    &::marker {
      font-weight: 500;
    }

    > span {
      font-weight: 500;
    }
  }
`;

export const BottomSection = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 16px 24px 16px;
`;

export const LinkSection = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border-radius: 18px;
  background: ${commonColors.white};
  box-shadow: 0 4px 10px 0 rgba(26, 40, 104, 0.1);
`;

export const LinkInfo = styled('div')`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  > h2 {
    color: ${commonColors.grey900};
    font-family: Unica77;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0.08px;
  }
  > p {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${commonColors.grey900};
    font-family: Unica77;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    letter-spacing: 0.07px;
  }
`;

export const LinkButtons = styled('div')`
  display: flex;
  align-items: center;
  gap: 6px;

  > button {
    all: unset;
    box-sizing: border-box;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 44px;
    border-radius: 110px;
    background-color: ${commonColors.grey900};

    > svg {
      width: 22px;
      height: 22px;
    }

    &.copy-button {
      background-color: ${commonColors.blue700};

      &.active {
        background-color: ${commonColors.green700};
      }
    }
  }
`;

export const QRCodeSection = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const QRCodeWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 270px;
  height: 270px;
  border-radius: 24px;
  border: 1.404px solid rgba(0, 99, 246, 0.05);
  background: linear-gradient(180deg, #fafafa 0%, #ebedf2 100%);
`;

export const QRCodeStyled = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 242px;
  height: 242px;
  border-radius: 16px;
  background: linear-gradient(180deg, #fafafa 0%, #ebedf2 100%);
  box-shadow: 0 5px 15px 0 rgba(26, 40, 104, 0.15);

  .qrcode-svg {
    width: 144px;
    height: 144px;
  }
`;

export const QRCodeInfo = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 8px;

  > h2 {
    color: ${commonColors.grey900};
    text-align: center;
    font-family: Unica77;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
  }

  > p {
    color: ${commonColors.grey700};
    text-align: center;
    font-family: Unica77;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.08px;
  }
`;
